<template>
  <div class="container reportDetail">
    <div class="nodeList" v-if="!isNew">
      <!-- 新增的 时候不显示 -->
      <el-steps :active="stepsActive" process-status="finish " finish-status="success">
        <el-step :key="index" v-for="(item, index) in nodeList" :title="item.nodeName"></el-step>
      </el-steps>
    </div>
    <el-button v-acl="FullPdfDownload" type="primary" @click="exportPDF">{{ $t('storeFeedback.report.completeVersionPDF')
    }}</el-button>
    <!--完整版PDF-->
    <el-button v-if="canPublish" type="primary" @click="prePublish">{{ $t('storeFeedback.report.publish') }}</el-button>
    <!--<el-button v-acl="SimplePdfDownload" type="primary" @click="exportPDF">{{$t('storeFeedback.report.lightVersionPDF')}}</el-button>-->
    <!--简易版PDF-->
    <el-button type="primary" @click="historyBack">{{ $t('common.close') }}</el-button>
    <!--关闭-->
    <el-button type="primary" v-acl="Feedback - reportsCopyCreate" v-if="isSUP && !isNew && status != 'suspend'"
      @click="copyCreate">{{ $t('common.copy') }}</el-button><!-- 供应商可以复制创建 -->
    <div class="handle-box">
      <el-tabs v-model="currentTab">
        <el-tab-pane v-for="(report, index) in feedbackInfo.feedbackReports"
          :label="report.reportNo == null ? 'NEW' : report.reportNo" :name="`${index}`" :key='`${index}`'>
          <ReportDetail_ReportItem :ref="`feedbackReports${index}`" v-model="feedbackInfo.feedbackReports[index]"
            :feedback="feedbackInfo.feedback" disabled="" :childRef="'directrecordwp' + index"></ReportDetail_ReportItem>
        </el-tab-pane>
        <el-tab-pane :label="$t('storeFeedback.report.feedbackDetail')" name="feedbackInfo.feedbackReports.length">
          <ReportDetail_feedbackDetail v-model="feedbackInfo.feedback" />
        </el-tab-pane>
        <!-- 新增、供应商如果最终信息为空的 时候不显示最终扣账信息 -->
        <el-tab-pane :label="$t('storeFeedback.report.finalDebitInfo')"
          v-if="(isSUP && feedbackInfo.feedbackDebits && feedbackInfo.feedbackDebits.length > 0) || (!isSUP && !isNew)"
          name="finalDebitInfo">
          <div class="toolsBox" v-if="operationDeductAccounts">
            <!-- bug3377 只要配置了新增扣账信息的权限就允许新增，不用区分是不是反馈中心 -->
            <el-button type="primary" v-acl="FeedbacksDebitsSave" @click="saveInfo('SAVE')">{{ $t('common.save')
            }}</el-button>
            <el-button type="primary" v-acl="FeedbacksDebitsSubmit" @click="saveInfo('SUBMIT')">{{ $t('common.submit')
            }}</el-button>
            <el-button type="primary" size="small" v-acl="FeedbacksDebitsSave"
              @click="sendData('SAVE')">下发餐厅扣账信息</el-button>

            <el-divider></el-divider>
          </div>
          <el-row style="margin-top:10px;">
            <el-form :inline="true" :model="feedbackInfo.feedback" :rules="rules" ref="restaurantNumForm"
              class="demo-form-inline">
              <el-form-item label="餐厅扣账数量" prop="storeDebitQty">
                <el-input v-model="feedbackInfo.feedback.storeDebitQty"
                  :disabled="!(operationDeductAccounts && haveFeedbacksDebitsNew) || feedbackInfo.feedback.isIssued == '是' ? true : false"></el-input>
              </el-form-item>
              <el-form-item label="是否下发成功" prop="isIssued">
                <div>
                  <!-- {{ feedbackInfo.feedback.isIssued?'是':'否' }} -->
                </div>
                <el-input v-model="feedbackInfo.feedback.isIssued" disabled></el-input>
              </el-form-item>
              <el-form-item label="下发时间" prop="issueDate">
                <div>
                  <!-- {{ feedbackInfo.feedback.issueDate }} -->
                </div>
                <el-input v-model="feedbackInfo.feedback.issueDate" disabled></el-input>
              </el-form-item>
            </el-form>
          </el-row>

          <div class="toolsBox" v-if="operationDeductAccounts" style='margin-bottom:20px'>
            <el-button type="primary" size="small" v-acl="FeedbacksDebitsSave" @click="addRow">{{ $t('common.addNewRow')
            }}</el-button>
            <el-button type="danger" size="small" v-acl="FeedbacksDebitsSave" @click="delRow">{{ $t('common.delRow')
            }}</el-button>
          </div>

          <el-table :data="feedbackInfo.feedbackDebits" ref="feedbackDebits" align="center" border highlight-current-row
            class="table">
            <!-- <el-table-column type="selection"></el-table-column> -->
            <el-table-column label="选择" width="50">
              <template slot-scope="scope">
                <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)"
                  :label="scope.row.delIds">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="debitMonth" :label="$t('storeFeedback.debitMonth')">
              <template slot-scope="scope">
                <!-- <el-date-picker popper-class="mouthClass" v-model="scope.row.debitMonth" type="month" :disabled='!(operationDeductAccounts &&haveFeedbacksDebitsNew)' placeholder="选择月">
                </el-date-picker> -->
                <el-date-picker v-model="scope.row.debitMonth" value-format="yyyy-MM" format="yyyy-MM" type="month"
                  :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)' placeholder="选择月">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="supDebitNum" :label="$t('storeFeedback.supDebitNum')">
              <template slot-scope="scope">
                <el-input type="number" oninput="if(value.length > 10) value=value.slice(0, 10)"
                  v-model="scope.row.supDebitNum"
                  :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)'></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="dcDebitNum" :label="$t('storeFeedback.dcDebitNum')">
              <template slot-scope="scope">
                <el-input type="number" oninput="if(value.length > 10) value=value.slice(0, 10)"
                  v-model="scope.row.dcDebitNum"
                  :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)'></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="debitRemark" :label="$t('common.remarks')" align="left">
              <template slot-scope="scope">
                <el-input v-model="scope.row.debitRemark" :disabled='!(operationDeductAccounts && haveFeedbacksDebitsNew)'
                  maxlength="200"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible="showPublishDialog" @close="showPublishDialog = false" width="1000px" class="publishDialog">
      <el-form inline label-width="200px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.publishUser')">
              <el-input disabled type="text" :value="currentUserName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.publishDate')">
              <el-date-picker disabled :value="new Date()" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('storeFeedback.report.reportNo')" class="widthReset">
              <el-input disabled type="textarea" autosize :value="publishNos"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最终责任方" class="widthReset is-required" prop="finalResponsibleParty">
              <IcSelect table='TT_FEEDBACK_REPORT' field='FINAL_RESPONSIBLE_PARTY' v-model="finalResponsibleParty"
                clearable></IcSelect>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('storeFeedback.report.publishAnalysis')" class="widthReset" required>
              <el-input maxlength="1000" type="textarea" :autosize="{ minRows: 4 }" v-model="publishAnalysis"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row justify="center" type="flex">
          <el-button type="primary" @click="publish">{{ $t('storeFeedback.report.publish') }}</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import reportApi from "@/api/storeFeedback/report";
import { Message } from 'element-ui'
import ReportDetail_ReportItem from "@/components/page/storeFeedback/reportDetail_reportItem";
import commonFun from "@/utils/commonFun";
import ReportDetail_feedbackDetail from "@/components/page/storeFeedback/reportDetail_feedbackDetail";
import Watermark from '@/utils/watermark';
import IcSelect from "@/components/common/icSelect";
export default {
  components: { ReportDetail_feedbackDetail, ReportDetail_ReportItem, IcSelect },
  data() {
    return {
      currentUserName: null,
      publishAnalysis: null,
      finalResponsibleParty: null,
      publishReports: [],
      showPublishDialog: false,
      canPublish: false,
      isNew: false,
      isStore: false,
      isFBC: false,
      isMCD: false,
      isSUP: false,
      nodeList: [],
      stepsActive: -1,
      rules: {
        storeDebitQty: [
          { required: true, message: '请输入餐厅扣账数量后再下发!', trigger: 'blur' }
        ],
      },
      // operationDeductAccounts:false,
      operationDeductAccounts: true,
      haveFeedbacksDebitsNew: true,
      feedbackId: null,
      feedbackReportId: null,
      feedbackInfo: {
        feedbackReports: [],
        feedback: {
          feedbackFirstCheck: {},
          feedbackComplaint: {},
          feedback: {}
        },
      },
      // feedbackReports:[],
      isCopyCreate: false,
      tabList: [],
      currentTab: '0',
      roles: [],
      radioVal: null,
      selectRow: null,
      status: '',
    }
  },
  created() {
    let that = this;
    that.roles = JSON.parse(localStorage.getItem("ms_roles"));
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    //门店      SF_STORE_BASIC
    //反馈中心  SF_FBC_BASIC
    //麦当劳   SF_MCD_BASIC
    //供应商  SF_SUP_BASIC
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
        // this.operationDeductAccounts = true //只有反馈中心可以操作扣账信息
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
      }
    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
    }
    this.getData().then(value => {
      if (that.feedbackReportId != null) {
        that.feedbackInfo.feedbackReports.forEach((report, index) => {
          if (that.feedbackReportId == report.ttFeedbackReportId) {
            that.currentTab = `${index}`;
          }
        });
      }
    })
    if (this.$route.query.debitInfo) {//如果从 报告列表 点击 新增扣账信息 进来的
      this.currentTab = "finalDebitInfo"
    }
    if (this.$route.query.action) {
      let action = this.$route.query.action;
      this.action = action
      if (action == 'create') {
        this.isNew = true
      }
    }
    // 如果没有新增扣账信息权限
    if (this.actionCheck.actionCheck('FeedbacksDebitsNew') === false) {
      this.haveFeedbacksDebitsNew = false
    }

  },
  mounted() {
    this.currentUserName = localStorage.getItem("ms_username");
    // this.$nextTick(() => {
    //     console.log(this.$refs.childRef)
    // })
  },
  computed: {
    publishNos() {
      return this.publishReports.map(report => report.reportNo).join(",");
    }
  },
  methods: {
    getData() {
      this.feedbackId = this.$route.query.feedbackId;
      this.feedbackReportId = this.$route.query.feedbackReportId;

      let action = this.$route.query.action;
      let that = this;
      if (action == 'create') {
        return reportApi.newReportInit(this.feedbackId).then(resp => {
          that.feedbackInfo = resp.data;
          this.$set(that.feedbackInfo.feedback, 'storeDebitQty', resp.data.feedback.feedback.storeDebitQty)
          this.$set(that.feedbackInfo.feedback, 'isIssued', resp.data.feedback.feedback.isIssued ? '是' : '否')
          this.$set(that.feedbackInfo.feedback, 'issueDate', resp.data.feedback.feedback.issueDate)

          // that.feedbackInfo.feedback.storeDebitQty = resp.data.feedback.feedback.storeDebitQty;
          // that.feedbackInfo.feedback.isIssued = resp.data.feedback.feedback.isIssued?'是':'否';
          // that.feedbackInfo.feedback.issueDate = resp.data.feedback.feedback.issueDate;
          that.tabList = [...that.feedbackInfo.feedbackReports, that.feedbackInfo.feedback, that.feedbackInfo.feedbackDebits];
        });
      } else {

        return reportApi.getDetail(this.feedbackId, this.feedbackReportId).then(resp => {
          that.feedbackInfo = resp.data;
          this.$set(that.feedbackInfo.feedback, 'storeDebitQty', resp.data.feedback.feedback.storeDebitQty)
          this.$set(that.feedbackInfo.feedback, 'isIssued', resp.data.feedback.feedback.isIssued ? '是' : '否')
          this.$set(that.feedbackInfo.feedback, 'issueDate', resp.data.feedback.feedback.issueDate)
          // that.feedbackInfo.feedback.storeDebitQty = resp.data.feedback.feedback.storeDebitQty;
          // that.feedbackInfo.feedback.isIssued = resp.data.feedback.feedback.isIssued ? '是' : '否';
          // that.feedbackInfo.feedback.issueDate = resp.data.feedback.feedback.issueDate;
          that.feedbackId = that.feedbackInfo.feedback.feedback.ttFeedbackId;

          that.canPublish = resp.data.feedback.canPublish;
          that.status = resp.data.feedback.feedback.status
          if (that.feedbackInfo.feedbackDebits.length > 0) {
            //循环数组添加删除用的标示
            for (let i = 0, len = that.feedbackInfo.feedbackDebits.length; i < len; i++) {
              that.feedbackInfo.feedbackDebits[i].delIds = i
              that.feedbackInfo.feedbackDebits[i].debitMonth = that.feedbackInfo.feedbackDebits[i].debitMonth.toString()
            }
          }

          if (resp.data.feedback.feedback.debitStatus == 'SUBMIT') {
            this.operationDeductAccounts = false//提交后不能操作 扣账
          }
          let nodeList = resp.data.feedback.nodeList
          for (let a = 0, len3 = nodeList.length; a < len3; a++) {
            if (nodeList[a].status == 'current') {
              this.stepsActive = a;
            }
          }
          this.nodeList = nodeList
          // //获取审批日志的数组
          // let temp = resp.data.feedbackReports
          // let logList = []
          // for (let i = 0,len=temp.length;i<len;i++){
          //     if(temp[i].logs.length>0){
          //         for (let j = 0,len=temp[i].logs.length;j<len;j++){
          //             logList.push(temp[i].logs[j])
          //         }

          //     }
          // }
          // that.logList = logList
          that.tabList = [...that.feedbackInfo.feedbackReports, that.feedbackInfo.feedback, that.feedbackInfo.feedbackDebits];


        });
      }
    },
    saveInfo(status) {
      let that = this
      let list = this.feedbackInfo.feedbackDebits;
      let data = {
        storeDebitQty: this.feedbackInfo.feedback.storeDebitQty,
        debitList: list,
        status: status
      }
      if (status == 'SUBMIT') {
        if (list.length == 0) {
          that.$message({ message: this.$t('storeFeedback.report.NoDetailLines'), type: "warning" });
          return;
        }
        for (let i = 0, len = list.length; i < len; i++) {
          if (
            list[i].debitMonth == null ||
            list[i].debitMonth == "") {
            that.$message({ message: this.$t('storeFeedback.report.PleaseMonth'), type: "warning" });
            return;
          }
          if (
            (list[i].supDebitNum == null ||
              list[i].supDebitNum == "") &&
            (list[i].dcDebitNum == null ||
              list[i].dcDebitNum == "")
          ) {
            that.$message({ message: this.$t('storeFeedback.report.debitNumNoempty'), type: "warning" });
            return;
          }
        }
        this.$confirm(this.$t('quoteByLine.sourcing.confirmSubmit'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          reportApi.saveDebitInfo(this.feedbackId, data).then(resp => {
            if (resp.code == 200) {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.operationDeductAccounts = false

            }
          });
        }).catch(() => {

        });
      } else {
        reportApi.saveDebitInfo(this.feedbackId, data).then(resp => {
          if (resp.code == 200) {
            that.$message({
              message: this.$t("common.saveSuccess"),
              type: "success"
            });

          }
        });
      }

    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = row;
    },
    addRow() {
      let len = this.feedbackInfo.feedbackDebits.length
      var list = {
        delIds: len,
      };
      this.feedbackInfo.feedbackDebits.push(list);
    },
    delRow() {
      let that = this;
      if (that.radioVal == null || that.selectRow == null) {
        that.$message({ message: this.$t('common.pleaseSelectOneData'), type: "warning" });
        return;
      }
      let list = this.feedbackInfo.feedbackDebits;
      // 遍历源数据
      list.forEach(function (itemI, indexI) {
        if (that.selectRow.delIds === itemI.delIds) {
          list.splice(indexI, 1);
        }
      });
      for (let i = 0, len = list.length; i < len; i++) {
        list[i].delIds = i
      }
      that.feedbackInfo.feedbackDebits = list
    },
    sendData(status) {
      this.$refs['restaurantNumForm'].validate((valid) => {
        if (valid) {
          let list = this.feedbackInfo.feedbackDebits;
          let data = {
            storeDebitQty: this.feedbackInfo.feedback.storeDebitQty,
            debitList: list,
            status: status
          }
          reportApi.storeDebitIssue(this.feedbackId, data).then((res) => {
            if (res.code == 200) {
              Message.success('下发成功');
              this.getData()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    copyCreate() {
      let that = this;
      if (this.feedbackInfo.feedbackReports[this.currentTab]) {
        let ttFeedbackReportId = this.feedbackInfo.feedbackReports[this.currentTab].ttFeedbackReportId
        reportApi.copyCreateFeedbackReport(ttFeedbackReportId).then(resp => {
          that.currentTab = '0'
          that.$router.replace({
            name: `feedbackReportView`,
            query: {
              feedbackId: resp.data.ttFeedbackId,
              feedbackReportId: resp.data.ttFeedbackReportId,
              timestamp: new Date().getTime()
            }
          })
        });
      }


    },
    historyBack() {
      this.$router.push({//返回列表
        name: `feedbackReport`,
      })
      // window.history.go(-1);
      // if(this.action == 'create'){
      //     this.$router.push({//返回列表
      //         name: `feedback`,
      //     })
      // }else{
      // }

    },
    exportPDF: function () {
      reportApi.exportPDF(this.feedbackId).then((res) => { })
    },
    prePublish: function () {
      let that = this;
      let publishReports = [];
      this.feedbackInfo.feedbackReports.forEach((value, index) => {
        let publishFlag = that.$refs[`feedbackReports${index}`][0].publishFlag;
        if (publishFlag) {
          publishReports.push(value);
        }
      })
      if (publishReports.length == 0) {
        Message.error(this.$t('storeFeedback.report.pleaseSelectPublishReports'));
        return;
      }
      this.publishReports = publishReports;
      this.showPublishDialog = true;
    },
    publish: function () {
      let that = this;
      let reportIds = this.publishReports.map(report => report.ttFeedbackReportId)
      let analysis = this.publishAnalysis;
      if (commonFun.isEmpty(this.finalResponsibleParty)) {
        Message.error('请选择最终责任方');
        return;
      }
      if (commonFun.isEmpty(analysis)) {
        Message.error(this.$t('storeFeedback.report.pleaseInputAnlisys'));
        return;
      }
      reportApi.publish({
        reportIds: reportIds,
        analysis: analysis,
        finalResponsibleParty: this.finalResponsibleParty
      }).then(res => {
        if (res.code == 200) {
          Message.success(that.$t("common.operateSuccess"));
          this.showPublishDialog = false;
          that.$router.push({ name: 'feedbackReport' });
        }
      });
    }
  },
  watch: {
    '$route.query'(to, from) {
      this.getData();
    },
    // feedbackReports:function(){
    //     let that = this
    //     this.$nextTick(function(){
    //         if(that.feedbackInfo.feedbackReports.length>0){
    //             for (let j = 0, len2 = that.feedbackInfo.feedbackReports.length; j < len2; j++){
    //                 console.log( that.$refs[`directrecordwp${j}`][j].$refs)
    //                 console.log( that.$refs[`directrecordwp${j}`])
    //                 Watermark.set('水印水印', that.$refs[`directrecordwp${j}`][j].$refs)

    //             }
    //         }
    //     });
    // }
  }
}

</script>
<style scoped>
.reportDetail .nodeList {
  margin-bottom: 20px;
}
</style>
<style>
.publishDialog .widthReset {
  width: 100%;
}

.publishDialog .widthReset .el-form-item__content {
  width: calc(100% - 200px);
}

.mouthClass .el-date-picker__header--bordered {
  display: none;
}

.reportDetail .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>

